import { render, staticRenderFns } from "./LoyaltyTransaction.vue?vue&type=template&id=13410833&"
import script from "./LoyaltyTransaction.vue?vue&type=script&lang=js&"
export * from "./LoyaltyTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports